<template>
    <div class="record">
        <CoHeader title="抽奖记录" :bgNone="true" type="team"/>
        <div class="recordBox">
            <div class="con">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    :immediate-check="false"
                    finished-text="没有更多了"
                    @load="getActivityRaffleMyList"
                >
                    <div v-for="(item, index) in list" :key="'record'+index" class="item" @click="goDetail">
                        <div class="left">
                            <p>{{ item.coupon_name }}</p>
                            <span>{{item.created_at}}</span>
                        </div>
                        <div class="right">
                            <van-icon name="arrow" />
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
import { getActivityRaffleMyList } from '../../../api/activity';
import jsbridg from '@/utils/jsbridg.js'
import CoHeader from "@/components/common/CoHeader"
import { isJHApp } from '@/utils/base.js'

export default {
    name: 'record',
    components: {
        CoHeader
    },
    data () {
        return {
            isAppOpen: isJHApp(),
            loading: false,
            finished: false,
            page: 1,
            list: []
        }
    },
    created () {
        jsbridg.hideAppBar(0)
        this.getActivityRaffleMyList();
        document.getElementsByTagName('title')[0].innerHTML = '获奖记录';
    },
    methods: {
        goDetail () {
            // jsbridg.goWebview({
            //     url: process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step14',
            //     jumptype: 2
            // });
            window.location.href = process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step14'
        },
        async getActivityRaffleMyList () {
            this.loading = true;
            const res = await getActivityRaffleMyList({
                page: this.page++
            })
            if (res.errno === 0) {
                if (res.data && res.data.list.length > 0) {
                    this.list.push(...res.data.list);
                } else {
                    this.finished = true;
                }
            } else {
                this.$toast(res.msg || '获取数据失败');
                this.finished = true;
            }
            this.loading = false;
        }
    }
}
</script>

<style lang="less" scoped>
.record{
    width: 100%;
    min-height: 100vh;
    background-color: #F6F8FB;
    .recordBox{
        padding: 12px;
    }
    .con{
        background-color: #fff;
        border-radius: 8px;
        padding: 0 16px;
        .item{
            width: 100%;
            height: 78px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #EEEEEE;
            &:last-child{
                border-bottom: none;
            }
            .left{
                width: calc(100% - 30px);
                p{
                    font-size: 16px;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                span{
                    font-size: 12px;
                    color: #999;
                }
            }
            .right{
                font-size: 16px;
                color: #333;
                width: 24px;
                text-align: center;
            }
        }
    }
}
</style>
